$(function () {

    const productBannerSlider = $(".product__banner__slider");
    const navBannerSlider = $(".product__banner__nav").flickity({
        asNavFor : ".product__banner__slider",
        contain : false,
        wrapAround : false,
        cellAlign: "left",
        groupCells: 3,
        prevNextButtons : false,
        pageDots : false,
        imagesLoaded : true,
        adaptiveHeight: true,
        on : {
            ready : function() {
                $(".product__banner__nav .flickity-viewport").height(
                    $(".product__banner__nav li").eq(0).height()
                )
            }
        }
    })

    let index = 1;

    productBannerSlider.flickity({
        wrapAround: false,
        prevNextButtons: false,
        imagesLoaded: true,
        adaptiveHeight: true,
        pageDots: false,
        draggable: true,
        contain: true,
        lazyLoad: true
    })

    $("#product-slider-wrapper").find(".flickity-control span").on("click", function () {
        flickityControl($(this), $(productBannerSlider))        
    })

})